import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * Stub home page rendered for unauthenticated visitors. Authenticated users
 * are redirected to `/meetings` by the index route component (`routes/index`).
 */
export function HomePage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">
          {t("app.title")}
        </h1>
        <p className="text-sm text-muted-foreground">{t("app.subtitle")}</p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>{t("home.quickNav")}</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/login"
                className="text-primary underline-offset-4 hover:underline"
              >
                {t("nav.login")}
              </Link>
            </li>
            <li>
              <Link
                to="/meetings"
                className="text-primary underline-offset-4 hover:underline"
              >
                {t("nav.meetings")}
              </Link>
            </li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
